module.exports = __webpack_public_path__ + "static/img/06-zzq.1d57f8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-shouye/06-zzq.jpg
// module id = HWBB
// module chunks = 1